module.exports = __webpack_public_path__ + "static/media/newlogo.4af5222e.png";